<template>
    <div>        
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <label>Empresa</label>
                        <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                            @change="listarCentrosCustos"/>
                    </div>   
                    <div class="p-field p-col-12 p-md-6">                           
                        <div class="p-field-checkbox">
                            <Checkbox v-model="ativo" :binary="true"/>
                            <label>Ativo</label>
                        </div>
                    </div>                      
                </div>
            </div>
            <div class="p-col-12 p-md-6">
                <div class="p-fluid p-formgrid p-grid">                            
                    <div class="p-field p-col-9">
                        <label>Centro de custo</label>               
                        <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                            dataKey="keyRefId" :filter="true" :showClear="true"/>
                    </div> 
                    <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Buscar" icon="pi pi-search" @click="buscarFuncionarios('soCtCt')"/>
                    </div>   
                    <div class="p-field p-col-9 p-md-9">                        
                        <div class="p-inputgroup">
                            <InputText v-model.trim="crachaNome" 
                            @keyup.enter="buscarFuncionarios('crachaNome')" 
                            @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')" 
                            placeholder="crachá/pis/cpf/nome"/>
                            <Button icon="pi pi-search" title="Buscar" @click="buscarFuncionarios('crachaNome')"/>                    
                        </div>
                    </div>          
                </div>
            </div>
        </div>
        <PickList v-model="funcionarios" listStyle="height:300px" dataKey="id">
            <template #sourceHeader>
                Funcionários Disponíveis
            </template>
            <template #targetHeader>
                Funcionários Selecionados
            </template>
            <template #item="slotProps">
               <div>
                   {{slotProps.item.cracha}} {{slotProps.item.nome}}
               </div>
           </template> 
        </PickList>
    </div>
</template>

<script>
import FuncionarioPesquisaService from '@/service/FuncionarioPesquisaService';
import CentroCustoService from '@/service/CentroCustoService';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
    centroCustoService: null,
    funcionarioPesquisaService: null,  
    data() {
        return {        
            ativo: true,
            crachaNome: '',           
            idCentroCustoSelecionado: null,
            idCnpjSelecionado: null,           
            cnpjs:[],            
            centrosCustos: [],
            funcionarios: null
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao', 'getCacheEmpresa']),      
        ...mapActions('sessao', ['atualizarCacheEmpresa']),  
        buscarFuncionarios(filtrarPor){
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);                
            }
            let requisicao = {
                crachaNome: this.crachaNome,
                ativo: this.ativo,
                idsCentrosCustos: idsCentrosCustos,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            if(filtrarPor == 'crachaNome') {
                this.funcionarioPesquisaService.buscarFuncionariosCrachaNome(requisicao)
                    .then(resp => {                                          
                        this.funcionarios = [resp.data, []];                  
                    })
                    .catch(erro => {exibirMensagem(this, erro)});
            } else {// Somente centros de custos
                this.funcionarioPesquisaService.buscarFuncionarios(requisicao)
                    .then(resp => {                                          
                        this.funcionarios = [resp.data, []];                  
                    })
                    .catch(erro => {exibirMensagem(this, erro)});
            }            
        },
        /**
         * 
         */       
        listarCnpjs() {
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            centroCusto['keyRefId'] = Date.now();
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        /**
         * 
         */
        listarCentrosCustos() {
            let cacheEmpresa = this.getCacheEmpresa();
            cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado; 
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {           
                // Cache dados      
                cacheEmpresa.centrosCustos = [];        
                let dataKey = 1;               
                resp.data.forEach(ct => {
                    ct['keyRefId'] = dataKey++;
                    cacheEmpresa.centrosCustos.push({...ct});
                });     
                this.idContratoSelecionado = null;                     
                this.centrosCustos = []; 
                let centroCusto = new CentroCusto();
                centroCusto.nome = 'Todos';
                centroCusto['keyRefId'] = Date.now();
                this.centrosCustos.push(centroCusto);
                Array.prototype.push.apply(this.centrosCustos, resp.data);     
                this.atualizarCacheEmpresa(cacheEmpresa);           
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },
        getCnpjs() {
            return [...this.cnpjs];
        },
        getCnpj() {            
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return null;
            }
            let cnpj = null;
            this.cnpjs.forEach(item => {
                if(item.id == this.idCnpjSelecionado) {
                    cnpj = item;
                }
            });
            return cnpj;
        },
        getFuncionarios() {
            let dados = {
                cnpj: {},
                funcionarios: [],
                ativo: this.ativo,
                todos: false,
                idsCentrosCustos: []
            };
            if(this.funcionarios == null) {
               return dados;
            }
            let cnpj = null;
            this.cnpjs.forEach(item => {
                if(item.id == this.idCnpjSelecionado) {
                    cnpj = item;
                }
            });
            dados.cnpj = cnpj;
            dados.funcionarios = this.funcionarios[1];
            dados.todos = this.funcionarios[0].length == 0 ? true : false;
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado) {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
                dados.idsCentrosCustos = idsCentrosCustos;
            }            
            if(this.funcionarios[1].length <= 50) {
                dados.todos = false;
            }            
            return dados;
        },
        getCentrosCustos() {
            let centrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        centrosCustos.push(ct.id);
                    }
                });
            } else {
                centrosCustos.push(this.idCentroCustoSelecionado);
            }
            return centrosCustos;
        }
    },
    created() {
        this.centroCustoService = new CentroCustoService();
        this.funcionarioPesquisaService = new FuncionarioPesquisaService();       
    },
    mounted() {
        this.listarCnpjs();
    }
}
</script>

<style>

</style>